import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['siren', 'registrationNumber']

  static values = {
    message: String
  }

  connect () {
    this.initialSiren = this.sirenTarget.value
    this.initialRegistrationNumber = this.registrationNumberTarget.value
  }

  submit (event) {
    if (!this.#legalIdsChanged()) return
    if (window.confirm(this.messageValue)) return

    event.preventDefault()
    event.stopImmediatePropagation()
  }

  #legalIdsChanged () {
    return this.sirenTarget.value !== this.initialSiren ||
      this.registrationNumberTarget.value !== this.initialRegistrationNumber
  }
}
